import Activities from './activities';
import Attachments from './attachments';
import Contacts from './contacts';
import History from './history';
import Leads from './leads/leads_tab';
import Listing from './listing';
import Overview from './overview';
import Planner from './planner';
import RelatedDeals from './related_deals';
import Voucher from './voucher';

import {
  faBolt,
  faClockRotateLeft,
  faFileInvoiceDollar,
  faHandshake,
  faHome,
  faList,
  faPaperclip,
  faSign,
  faUsers,
} from '@fortawesome/pro-solid-svg-icons';

export function getInvalidFieldsByTab(fields, invalidFields) {
  const overview = [];
  const contacts = [];
  const planner = [];

  invalidFields.forEach((name) => {
    const field = fields[name];
    if (field) {
      if (field.isContact) {
        contacts.push(name);
      } else if (field.isDate) {
        planner.push(name);
      } else {
        overview.push(name);
      }
    }
  });

  return { contacts, planner, overview };
}

export function getTabs(fields = {}, invalidFields = [], hasRelatedDeals, isParentDeal, features = {}, hasListing) {
  const showProjectLeads = features.projectLeads;
  const restricted = features.restrictedApex;
  const viewVoucher = features.viewVoucher;

  const tabs = {
    activities: {
      icon: faBolt,
      label: 'Activities',
      key: 'activities',
      path: '/activities',
      component: Activities,
    },

    attachments: {
      icon: faPaperclip,
      label: 'Attachments',
      key: 'attachments',
      path: '/attachments',
      component: Attachments,
    },

    contacts: {
      icon: faUsers,
      label: 'Contacts',
      key: 'contacts',
      path: '/contacts',
      component: Contacts,
    },

    history: {
      icon: faClockRotateLeft,
      label: 'History',
      key: 'history',
      path: '/history',
      component: History,
    },

    listing: {
      icon: faSign,
      label: isParentDeal ? 'Property' : 'Listing',
      key: 'listing',
      path: '/listing',
      component: Listing,
    },

    planner: {
      icon: faList,
      label: 'Planner',
      key: 'planner',
      path: '/planner',
      component: Planner,
    },

    relatedDeals: {
      icon: faHandshake,
      label: 'Related Deals',
      key: 'relatedDeals',
      path: '/relatedDeals',
      component: RelatedDeals,
    },

    voucher: {
      icon: faFileInvoiceDollar,
      label: 'Voucher',
      key: 'voucher',
      path: '/voucher',
      component: Voucher,
    },

    leads: {
      icon: faUsers,
      label: 'Leads',
      key: 'leads',
      path: '/project_leads',
      component: Leads,
    },

    overview: {
      icon: faHome,
      label: 'Overview',
      key: 'overview',
      path: '/',
      component: Overview,
    },
  };

  if (restricted) {
    delete tabs.attachments;
    delete tabs.activities;
    delete tabs.history;
    delete tabs.listing;
    delete tabs.voucher;
  }

  if (!viewVoucher) {
    delete tabs.voucher;
  }

  if (!hasRelatedDeals) {
    delete tabs.relatedDeals;
  }

  if (!showProjectLeads || !hasListing) {
    delete tabs.leads;
  }

  const invalidFieldsByTab = getInvalidFieldsByTab(fields, invalidFields);
  ['contacts', 'overview', 'planner'].forEach((tabName) => {
    if (invalidFieldsByTab[tabName].length) {
      tabs[tabName].badge = invalidFieldsByTab[tabName].length;
    }
  });

  return tabs;
}

export function getTabGroups(deal, features, fields, invalidFields, hasRelatedDeals) {
  const groups = [];
  const tabs = getTabs(fields, invalidFields, hasRelatedDeals, deal.parent, features, deal.listing);

  groups.push({
    label: 'Deal',
    key: 'deal',
    tabs: [
      tabs.overview,
      tabs.relatedDeals,
      tabs.contacts,
      tabs.planner,
      tabs.attachments,
      tabs.activities,
      tabs.history,
    ].filter(tab => tab),
  });

  if (features.listings && !features.restrictedApex && (deal.dealType === 'sale' || deal.dealType === 'lease')) {
    groups.push({
      label: 'Marketing',
      key: 'marketing',
      tabs: [
        tabs.listing,
        tabs.leads,
      ].filter(tab => tab),
    });
  }

  if (features.backoffice && !features.restrictedApex && features.viewVoucher && tabs?.voucher) {
    groups.push({
      label: 'Back Office',
      key: 'backoffice',
      tabs: [
        tabs.voucher,
      ],
    });
  }

  return groups;
}
